import { io } from "socket.io-client";

const socket = io("https://apitike.fysistemas.com");

export default socket;